class ComponentVideo extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      video: "video",
      button: "button"
    });
  }

  static get observedAttributes() {
    return ["playing"];
  }

  attributeChangedCallback(name, previous, value) {
    if (this.hasAttribute("playing")) {
      this.elements.video.play();
    } else {
      this.elements.video.pause();
    }
  }

  connectedCallback() {
    if (this.elements.video.hasAttribute("autoplay")) {
      return;
    }

    this.pauseOutsideViewport();
    super.connectedCallback();
  }

  play() {
    this.pauseAll();
    this.setAttribute("playing", true);
  }

  pause() {
    this.removeAttribute("playing");
  }

  pauseAll() {
    document.querySelectorAll("component-video").forEach(component => {
      component.pause();
    });
  }

  pauseOutsideViewport() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.pause();
        }
      });
    });

    observer.observe(this);
  }
}

customElements.define("component-video", ComponentVideo);
